import React, { Component } from "react";
import { Form, Button, Col, Row, Card } from "react-bootstrap";
import AddressDetails from "./addressComponent";
import "./index.css";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import {
  createParents, updateParentDetailsAction
} from "../../../redux/actions/studentActions";
import { EDIT_ACTION, PAYMENT } from "../../constants";
import UserPhoneNumber from "../../../common/UserPhoneNumber";
import AwesomePhoneNumber from 'awesome-phonenumber';
import {isValidPhoneNumber } from 'react-phone-number-input'
const ParentDetails = (props) => {
  const {changeTab  , redirectFrom , parentData} = props;
  console.log(parentData)
  const dispatch = useDispatch();
const { studentProfileDetails }  = useSelector(state => state.student)
  const validationSchema = Yup.object().shape({
     father:Yup.object().shape({
      name: Yup.string().required("First Name is required"),
      email: Yup.string().required("Email is required").email("Email is invalid"),
      dob: Yup.string().required("Date Of Birth is required"),
      phone: Yup.string().required("Phone number is required").nullable(),
      occupation: Yup.string().required("Occupation is required"),
      addressLine: Yup.string().required("Address  is required"),
      city: Yup.string().required("City For is Required"),
      district: Yup.string().required("Districtis required"),
      StateId: Yup.object().required("State is required").nullable(),
      postalCode: Yup.string().min(6, 'Zip Code must b 6 digits').max(6, 'Zip Code should not be greater than 6 digits').required("Zip is required"),
      altPhoneNumber:Yup.string().nullable()
     }),
     mother:Yup.object().shape({
      name: Yup.string().required("First Name is required"),
      email: Yup.string().required("Email is required").email("Email is invalid"),
      dob: Yup.string().required("Date Of Birth is required"),
      phone: Yup.string().required("Phone number is required").nullable(),
      occupation: Yup.string().required("Occupation is required"),
      addressLine: Yup.string().required("Address  is required"),
      city: Yup.string().required("City For is Required"),
      district: Yup.string().required("Districtis required"),
      StateId: Yup.object().required("State is required").nullable(),
      postalCode: Yup.string().min(6, 'Zip Code must b 6 digits').max(6, 'Zip Code should not be greater than 6 digits').required("Zip is required"),
      altPhoneNumber:Yup.string().nullable()
     })
  });
  let defaultValues = {
      father :{
        // email: studentProfileDetails.User.email,
        // phone: studentProfileDetails.User.phoneNumber,
      } ,
      mother :{
        email: studentProfileDetails.User.email,
        phone: studentProfileDetails.User.phoneNumber,
      } ,
  }
    if(studentProfileDetails.Addresses.length > 0 ){
        defaultValues= {
          father:{
            email: studentProfileDetails.User.email,
            phone: studentProfileDetails.User.phoneNumber,
            addressLine: studentProfileDetails.Addresses[0].addressLine,
            city: studentProfileDetails.Addresses[0].city,
            district: studentProfileDetails.Addresses[0].district,
            StateId: {value : studentProfileDetails.Addresses[0].State.id , label: studentProfileDetails.Addresses[0].State.name } ,
            postalCode: studentProfileDetails.Addresses[0].postalCode,
          },
          mother:{
            email: studentProfileDetails.User.email,
            phone: studentProfileDetails.User.phoneNumber,
            addressLine: studentProfileDetails.Addresses[0].addressLine,
            city: studentProfileDetails.Addresses[0].city,
            district: studentProfileDetails.Addresses[0].district,
            StateId: {value : studentProfileDetails.Addresses[0].State.id , label: studentProfileDetails.Addresses[0].State.name } ,
            postalCode: studentProfileDetails.Addresses[0].postalCode,
          }
        }

    }
    if(redirectFrom === EDIT_ACTION){
      defaultValues = {
        father: parentData.father,
        mother: parentData.mother,
      }
    }
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors },
    getValues,
    setError,
    clearErrors,
    setValue
  } = useForm({
    defaultValues:defaultValues,
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data) => {
    let fatherData = { ...data.father,address:data.father.address , gender: 'Male'}
    let motherData = { ...data.mother , address:data.mother.address,gender: 'Female'}
    // console.log(motherData.altPhoneNumber,isValidPhoneNumber(motherData.altPhoneNumber))
    // if(fatherData.altPhoneNumber && fatherData.altPhoneNumber.length < 10 && !isValidPhoneNumber(fatherData.altPhoneNumber)){
    //   console.log("Successds")
    //   setError("father.altPhoneNumber", { type: "focus",message: "Invalids Phone number", }, { shouldFocus: true });
    //   return true;
    // }
    // if(motherData.altPhoneNumber && motherData.altPhoneNumber.length < 10 && !isValidPhoneNumber(motherData.altPhoneNumber)){
    //   console.log("sadfasdf")
    //   setError("mother.altPhoneNumber", { type: "focus",message: "Invalids Phone number", }, { shouldFocus: true });
    //   return true;
    // }
    const fatherPhone = new AwesomePhoneNumber( `${fatherData.phone}`, 'IN' );
    const fatherAltPhone = new AwesomePhoneNumber( `${fatherData.altPhoneNumber}`, 'IN' );
    const motherPhone = new AwesomePhoneNumber( `${motherData.phone}`, 'IN' );
    const motherAltPhone = new AwesomePhoneNumber( `${motherData.altPhoneNumber}`, 'IN' );
    console.log(fatherPhone.getNumber( 'significant' ))
    fatherData.phone = fatherPhone.getNumber( 'significant' ); 
    fatherData.altPhoneNumber = fatherAltPhone.getNumber( 'significant' ); 
    motherData.phone = motherPhone.getNumber( 'significant' ); 
    motherData.altPhoneNumber = motherAltPhone.getNumber( 'significant' ); 
    if(redirectFrom === EDIT_ACTION){
      fatherData.id = parentData.father.id;
      motherData.id = parentData.mother.id;
      fatherData.StateId = parentData.father.StateId.value;
      motherData.StateId = parentData.mother.StateId.value;
      const parentDetails = [fatherData,motherData];
      console.log(fatherData,motherData)
      await dispatch(updateParentDetailsAction({parentDetails,StudentId:studentProfileDetails.id}));
    }else{
      fatherData.StateId = data.father.StateId.value;
      motherData.StateId = data.mother.StateId.value;
      const parentDetails = [fatherData,motherData];
      await dispatch(createParents({parentDetails,StudentId:studentProfileDetails.id}));
      reset();
      changeTab(PAYMENT)
    }
    
  };
  console.log(errors)
  const onError = async(data)=>{
    console.log(data)
  }
  const handlePhoneValidation =(phoneObj,inputKey)=>{
    console.log(phoneObj,inputKey)
    if(Object.keys(phoneObj).length > 0){
      if(phoneObj.isValid){
        clearErrors(`${inputKey}`);
        setValue(`${inputKey}`,phoneObj.data)
      }else{
        setValue(`"${inputKey}"`,phoneObj.data);
        setError(`${inputKey}`, { type: "focus",message: "Invalids Phone number", }, { shouldFocus: true });
      } 
    }else{
      setValue(`${inputKey}`,null)
    }
   
  }

  return (
    <>
      <Form noValidate onSubmit={handleSubmit(onSubmit,onError)}>
        <div className="row">
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 required">
            <Card>
              <Card.Header className="custom-card-header">
                Father Details
              </Card.Header>
              <Card.Body>
                <Form.Row>
                  <Form.Group
                    className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 required "
                    controlId="formFirstName"
                  >
                    <Form.Label className="label">Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      {...register("father.name")}
                      className={`form-control ${
                        errors.father && errors.father.name ? "is-invalid" : ""
                      }`}
                    />
                    <span className="invalid-feedback">
                      {errors.father && errors.father.name?.message}
                    </span>
                  </Form.Group>
                  <Form.Group
                    className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-6 required"
                    controlId="formLastName"
                  >
                    <Form.Label className="label">Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      {...register("father.email")}
                      className={`form-control ${
                        errors.father && errors.father.email ? "is-invalid" : ""
                      }`}
                      
                    />
                    <span className="invalid-feedback">
                      {errors.father && errors.father.email?.message}
                    </span>
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group
                    className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 required"
                    controlId="formFirstName"
                  >
                    <Form.Label className="label">Occupation</Form.Label>
                    <Form.Control
                      type="text"
                      name="occupation"
                      {...register("father.occupation")}
                      className={`form-control ${
                        errors.father && errors.father.occupation ? "is-invalid" : ""
                      }`}
                    />
                    <span className="invalid-feedback">
                      {errors.father && errors.father.occupation?.message}
                    </span>
                  </Form.Group>
                  <Form.Group
                    className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-6 required"
                    controlId="formLastName"
                  >
                    <Form.Label className="label">Date of Birth</Form.Label>
                    <Form.Control
                      type="date"
                      name="dob"
                      {...register("father.dob")}
                      className={`form-control ${
                        errors.father && errors.father.dob ? "is-invalid" : ""
                      }`}
                    />
                    <span className="invalid-feedback">
                      {errors.father && errors.father.dob?.message}
                    </span>
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group
                    className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 required"
                    controlId="dob"
                  >
                    <Form.Label className="label">WhatsApp Number</Form.Label>
                    {/* <Form.Control
                      type="text"
                      name="phone"
                      {...register("father.phone")}
                      className={`form-control ${
                        errors.father && errors.father.phone ? "is-invalid" : ""
                      }`}
                    /> */}
                    <UserPhoneNumber isRequired={false} errorClass={`form-control ${
                        errors.father && errors.father.phone ? "is-invalid" : ""
                      }`} onInputChange={(phoneInput)=>{
                        handlePhoneValidation(phoneInput,"father.phone")
                      }} value={ redirectFrom === EDIT_ACTION ? ( parentData.father.phone): null } inputKey={"father.phone"}/>
                    <span className="invalid-feedback">
                      {errors.father && errors.father.phone?.message}
                    </span>
                  </Form.Group>
                  <Form.Group
                    className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-6 "
                    controlId="age"
                  >
                    <Form.Label className="label">
                      Alternate No/Work No -
                    </Form.Label>
                    {/* <Form.Control
                      type="text"
                      name="altPhoneNumber"
                      {...register("father.altPhoneNumber")}
                      className={`form-control ${
                        errors.father && errors.father.altPhoneNumber ? "is-invalid" : ""
                      }`}
                    /> */}
                    <UserPhoneNumber isRequired={false} errorClass={`form-control ${
                        errors.father && errors.father.altPhoneNumber ? "is-invalid" : ""
                      }`} onInputChange={(phoneInput)=>{
                        handlePhoneValidation(phoneInput,"father.altPhoneNumber")
                      }} value={ redirectFrom === EDIT_ACTION ? ( parentData.father.altPhoneNumber): null }/>
                    <span className="invalid-feedback">
                      {errors.father && errors.father.altPhoneNumber?.message}
                    </span>
                  </Form.Group>
                </Form.Row>
                
                <AddressDetails register={register} errors={errors} formObjKey={'father'} control={control} />
              </Card.Body>
            </Card>
          </div>
          <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 required">
            <Card>
              <Card.Header className="custom-card-header">
                Mother Details
              </Card.Header>
              <Card.Body>
              <Form.Row>
                  <Form.Group
                    className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 required "
                    controlId="formFirstName"
                  >
                    <Form.Label className="label">Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      {...register("mother.name")}
                      className={`form-control ${
                        errors.mother && errors.mother.name ? "is-invalid" : ""
                      }`}
                    />
                    <span className="invalid-feedback">
                      {errors.mother && errors.mother.name?.message}
                    </span>
                  </Form.Group>
                  <Form.Group
                    className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-6 required"
                    controlId="formLastName"
                  >
                    <Form.Label className="label">Email</Form.Label>
                    <Form.Control
                      type="email"
                      name="email"
                      {...register("mother.email")}
                      className={`form-control ${
                        errors.mother && errors.mother.email ? "is-invalid" : ""
                      }`}
                      disabled={true}
                    />
                    <span className="invalid-feedback">
                      {errors.mother && errors.mother.email?.message}
                    </span>
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group
                    className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 required"
                    controlId="formFirstName"
                  >
                    <Form.Label className="label">Occupation</Form.Label>
                    <Form.Control
                      type="text"
                      name="occupation"
                      {...register("mother.occupation")}
                      className={`form-control ${
                        errors.mother && errors.mother.occupation ? "is-invalid" : ""
                      }`}
                    />
                    <span className="invalid-feedback">
                      {errors.mother && errors.mother.occupation?.message}
                    </span>
                  </Form.Group>
                  <Form.Group
                    className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-6 required"
                    controlId="formLastName"
                  >
                    <Form.Label className="label">Date of Birth</Form.Label>
                    <Form.Control
                      type="date"
                      name="dob"
                      {...register("mother.dob")}
                      className={`form-control ${
                        errors.mother && errors.mother.dob ? "is-invalid" : ""
                      }`}
                    />
                    <span className="invalid-feedback">
                      {errors.mother && errors.mother.dob?.message}
                    </span>
                  </Form.Group>
                </Form.Row>
                <Form.Row>
                  <Form.Group
                    className="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 required"
                    controlId="dob"
                  >
                    <Form.Label className="label">WhatsApp Number</Form.Label>
                    {/* <Form.Control
                      type="text"
                      name="phone"
                      {...register("mother.phone")}
                      className={`form-control ${
                        errors.mother && errors.mother.phone ? "is-invalid" : ""
                      }`}
                    /> */}
                    <UserPhoneNumber isRequired={false} errorClass={`form-control ${
                        errors.mother && errors.mother.phone ? "is-invalid" : ""
                      }`} onInputChange={(phoneInput)=>{
                        handlePhoneValidation(phoneInput,"mother.phone")
                      }} value={ redirectFrom === EDIT_ACTION ? ( parentData ? parentData.mother.phone : null ): defaultValues.mother.phone }
                      disabled={true}/>
                    <span className="invalid-feedback">
                      {errors.mother && errors.mother.phone?.message}
                    </span>
                  </Form.Group>
                  <Form.Group
                    className="col-xs-12 col-sm-12 col-md-6  col-lg-6  col-xl-6 "
                    controlId="age"
                  >
                    <Form.Label className="label">
                      Alternate No/Work No -
                    </Form.Label>
                    {/* <Form.Control
                      type="text"
                      name="altPhoneNumber"
                      {...register("mother.altPhoneNumber")}
                      className={`form-control ${
                        errors.mother && errors.mother.altPhoneNumber ? "is-invalid" : ""
                      }`}
                    /> */}
                    <UserPhoneNumber isRequired={false} errorClass={`form-control ${
                        errors.mother && errors.mother.altPhoneNumber ? "is-invalid" : ""
                      }`} onInputChange={(phoneInput)=>{
                        handlePhoneValidation(phoneInput,"mother.altPhoneNumber")
                      }} value={ redirectFrom === EDIT_ACTION ? ( parentData.mother.altPhoneNumber): null }/>
                    <span className="invalid-feedback">
                      {errors.mother && errors.mother.altPhoneNumber?.message}
                    </span>
                  </Form.Group>
                </Form.Row>

                <AddressDetails register={register} errors={errors} formObjKey={'mother'} control={control} />
              </Card.Body>
            </Card>
          </div>
        </div>
        <div className="spacer"></div>
        <div>
          <Button
            variant="btn app-default-button btn btn-primary"
            type="submit"
          >
             { redirectFrom === EDIT_ACTION ? "Update" : "Submit" }
          </Button>
        </div>
      </Form>
    </>
  );
};

export default ParentDetails;
